import React, { createContext, useState, useContext } from 'react';

const SearchTabContext = createContext();

export const SearchTabProvider = ({ children }) => {
  // Default to showing the 'home' content
  const [activeTab, setActiveTab] = useState('home'); 

  return (
    <SearchTabContext.Provider value={{ activeTab, setActiveTab }}>
      {children}
    </SearchTabContext.Provider>
  );
};

export const useSearchTab = () => useContext(SearchTabContext);